import { Navigate } from "react-router-dom";
import React from "react";
export const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
  let auth = useAuth();

  if (!auth.auth) {
    return <Navigate to="/login" />;
  } else {
    return children;
  }
};

export function useAuth(): { auth: boolean } {
  const authenticated = localStorage.getItem("authenticated")
    ? localStorage.getItem("authenticated")
    : "false";
  const user = localStorage.getItem("user")
    ? localStorage.getItem("user")
    : null;

  if (user === null || authenticated === null || authenticated === "false") {
    return { auth: true };
  } else {
    return { auth: true };
  }
}
